import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const AutoLogout = () => {
  const navigate = useNavigate();
  const [toastVisible, setToastVisible] = useState(false);

  const showSuccessToast = (message) => {
    if (!toastVisible) {
      setToastVisible(true);
      toast.success(
        <div className="toast-ml">
          <h4 className="toast-title">Success!</h4>
          <p className="toast-message">{message}</p>
        </div>,
        {
          onClose: () => setToastVisible(false), // Reset state on close
          autoClose: 3000, // Auto-close after 3 seconds
        }
      );
    }
  };

  const disconnectWallet = async () => {
    try {
      localStorage.clear();
      showSuccessToast("Session expired,Login to continue ");
    } catch (error) {
      // console.log(error, "error diccon");
    }
  };

  useEffect(() => {
    let timer;

    const resetTimer = () => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        sessionStorage.removeItem("token");
        localStorage.removeItem("token");
        disconnectWallet();
        navigate("/");
      }, 30 * 60 * 1000);
    };

    const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];

    const activityHandler = () => {
      resetTimer();
    };

    events.forEach((event) => {
      window.addEventListener(event, activityHandler);
    });

    resetTimer();

    return () => {
      clearTimeout(timer);
      events.forEach((event) => {
        window.removeEventListener(event, activityHandler);
      });
    };
  }, [navigate]);

  return null;
};

export default AutoLogout;
